export default {
    noData: 'Try to change\nor reset filter settings'
};
